<template>
    <div class="card">
        <div class="card-header">Update Social Security Number</div>
        <div class="card-body">
            <b-row>
                <b-col cols="12" lg="4">
                    <BaseTextInput v-model="application.license.socialSecurityNumber"
                                   :v="$v.application.license.socialSecurityNumber"
                                   slug="socialSecurityNumber"
                                   label="SSN"
                                   setId="licSocialSecurityNumber"
                    />
                </b-col>
                <b-col cols="12" lg="2" class="mt-2r">
                    <button class="btn btn-secondary" @click="onSubmit">
                        Update
                    </button>
                </b-col>
            </b-row>
        </div>
    </div>

</template>
<script>
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import { required } from 'vuelidate/lib/validators'
    import axiosRetry from 'axios-retry'
    import axios from "axios"

    export default {
        props: {
            application: {
                type: Object,
                default () {
                    return {
                        license: {
                            socialSecurityNumber: null
                        }
                    }
                }
            }
        },
        data: () => {
            return {
            }
        },
        components: {
            BaseTextInput
        },
        validations() {
            return {
                application: {
                    license: {
                        socialSecurityNumber: {required},
                    }
                },
                form: [ 'application' ]
            }
        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', 's', this.$data, isValid)
                return isValid
            },
            onSubmit() {
                this.application.mnSupervisor = null
                this.application.prevMnSupervisor = null
                this.validate()
                if (!this.$v.form.$invalid) {
                    var submitting = Object.assign({}, this.application, this.$data)
                    axiosRetry(axios, { retries: 0 })
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/contact/ssn/` + this.application.applicationId, submitting)
                        .then(response => {
                            this.showRootToast("Social Security Number Updates", "The SSN has been updated.", "success")
                        }) .catch(error => {
                        console.log(error)
                        this.showRootToast("Error", "An error has occurred " , "danger")
                    })
                }
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
        },
    }
</script>
